module.exports = __webpack_public_path__ + "img/CM-MC-25-Audi-Playful.0ac03eca.jpg";